import React, { useState, useContext } from "react";
import { Box, Heading, ResponsiveContext } from "grommet";
import { isMobileTabletResponsive } from "../../../utils/utils";
import { RoundCheckBox } from "../../Checkboxes/RoundCheckBox";
export var Gender = function Gender(_ref) {
  var _localStorage;

  var setNewData = _ref.setNewData;
  var size = useContext(ResponsiveContext);
  var isMobileWidth = isMobileTabletResponsive(size);
  var userObject =
    ((_localStorage = localStorage) == null ? void 0 : _localStorage.user) &&
    JSON.parse(localStorage.user);

  var _useState = useState((userObject == null ? void 0 : userObject.gender) || ""),
    gender = _useState[0],
    setGender = _useState[1];

  var handleGender = function handleGender(event) {
    var value = event.target.value;

    if (value) {
      setGender(value);
      setNewData({
        gender: value,
      });
    }
  }; //#TODO Notification about updating data
  // useEffect(() => {
  //   const timer = setTimeout(() => console.log('Updating...'), 3000)
  //   return () => {
  //     clearTimeout(timer)
  //   }
  // }, []);

  return /*#__PURE__*/ React.createElement(
    Box,
    {
      style: {
        borderRadius: "10px",
        backgroundColor: "#F8F8F8",
      },
      pad: "2rem",
    },
    /*#__PURE__*/ React.createElement(
      Heading,
      {
        level: 6,
      },
      "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0432\u0430\u0448 \u043F\u043E\u043B:"
    ),
    /*#__PURE__*/ React.createElement(
      Box,
      {
        flex: true,
        direction: isMobileWidth ? "column" : "row",
        gap: "2rem",
        margin: {
          top: "1.5rem",
        },
      },
      /*#__PURE__*/ React.createElement(
        Box,
        {
          flex: true,
        },
        /*#__PURE__*/ React.createElement(RoundCheckBox, {
          id: "male",
          name: "gender",
          value: "male",
          label: "\u041C\u0443\u0436\u0441\u043A\u043E\u0439",
          checked: gender === "male",
          onChange: handleGender, // disabled={disabled}
        })
      ),
      /*#__PURE__*/ React.createElement(
        Box,
        {
          flex: true,
        },
        /*#__PURE__*/ React.createElement(RoundCheckBox, {
          id: "female",
          name: "gender",
          value: "female",
          label: "\u0416\u0435\u043D\u0441\u043A\u0438\u0439",
          checked: gender === "female",
          onChange: handleGender, // disabled={disabled}
        })
      )
    )
  );
};
